<template>
  <div class="VacationRemain mb-2" v-if="pnlRemainVacationVisible">
    <box :title="this.$t('vacationRemain.title')">
      <div class="pa-3">
        
         <v-row>
          <v-col cols="6"
            ><span>مانده تا پایان ماه/دوره قبل</span>:<span class="text-value">{{remainUptoMonth}}</span></v-col
          >
          <v-col cols="6"
            >{{ $t("vacationRemain.MandeTapayanSal") }}:<span
              class="text-value"
              >{{remainUptoYear}}</span
            ></v-col
          >
        </v-row> 
      </div>
    </box>
  </div>
</template>

<script>
import ResultType from "../../model/ResultType";
import EosUtils from "../../utils/EosUtils";
export default {
  data() {
    return {
      year: null,
      month: null,
      vacationRemain: null,
      pnlRemainVacationVisible:false,
      remainUptoYear:"",
      remainUptoMonth:"",
    };
  },
  mounted() {
    //var periodType = this.$store.state.permission.periodType;
    ////console.log(periodType);
    this.pageLoad();
    //this.GetEosPeriodicYearsList();
  },
  methods: {
    async pageLoad() {
      if (EosUtils.isWebKartAdmin()) {
        return;
      }
      

      //this.GetEosPeriodicYearsList();
      this.GetVacationRemainDetail();
    },
    async GetVacationRemainDetail() {
      var DisableShowingMorLeft = false;
      var readwebkartsettingRes = await this.$store.dispatch(
        "readwebkartsetting"
      );
      if (readwebkartsettingRes.type == ResultType.success) {
        DisableShowingMorLeft =
          readwebkartsettingRes.data.DisableShowingMorLeft == "1";
      }
      if (DisableShowingMorLeft) {
        this.pnlRemainVacationVisible = false;
        return;
      }
      this.pnlRemainVacationVisible = true;

      var moment = require("jalali-moment");
      var year = moment().locale("fa").format("YYYY");
      var date = moment().locale("fa").format("MM/DD");

      var GetRemainMorakhasiUntilNowParams = {
        perno: this.$store.state.auth.auth.username,
        date: date,
        year: year,
      };
      this.$store
        .dispatch("GetRemainMorakhasiUntilNow", {
          GetRemainMorakhasiUntilNowParams,
        })
        .then((result) => {
          console.log(result);
          if (result.type === "success") {
            var remainUptoMonth = result.data[2];
            if (remainUptoMonth < 0) {
              this.remainUptoMonth =
                "-" + EosUtils.ConvertMinToHour(remainUptoMonth.toString());
            } else {
              this.remainUptoMonth = EosUtils.ConvertMinToHour(
                remainUptoMonth.toString()
              );
            }

            var remainUptoYear = result.data[3];
            if (remainUptoYear < 0) {
              this.remainUptoYear =
                "-" + EosUtils.ConvertMinToHour(remainUptoYear.toString());
            } else {
              this.remainUptoYear = EosUtils.ConvertMinToHour(
                remainUptoYear.toString()
              );
            }
          }
        });
    },
    /*GetEosPeriodicYearsList() {
      this.$store.dispatch("GetEosPeriodicYearsList").then((result) => {
        if (result.type === "success") {
          var data = [];
          data = result.data;
          //this.years = data;
          this.year = data.slice(-1)[0];
          this.getPeriods();
        }
      });
    },
    getPeriods() {
      if (!this.year) {
        return;
      }

      const params = new URLSearchParams();
      params.append("year", this.year.Name);

      this.$store.dispatch("GetEosPeriodList", { params }).then((result) => {
        ////console.log(result);
        if (result.type === "success") {
          var data = [];
          data = result.data;
          //this.months = data;
          this.month = data.slice(-1)[0];

          this.GetVacationRemainDetail();
        }
      });
    },
    GetVacationRemainDetail() {
      const params = new URLSearchParams();
      params.append("period", this.month);
      params.append("year", this.year.Name);

      this.$store
        .dispatch("GetVacationRemainDetail", { params })
        .then((result) => {
          ////console.log(result);
          if (result.type === "success") {
            this.vacationRemain = result.data;
          }
        });
    },*/
  },
};
</script>

<style>
</style>